module.exports = __webpack_public_path__ + "img/dhIntroduce0226.3418ddac.jpg";